import { useEffect } from 'react';
import { setChatOpen, setMenuOpen } from "../../../../entities/settings/model";
import { CHAT_WIDGET_EVENT_CHAT, CHAT_WIDGET_EVENT_MENU } from "../../../../shared/lib";
import { useAppDispatch } from "../../../../shared/model";
import { useInitialSubmit } from "../useInitialSubmit";
export var useChatEventControl = function useChatEventControl(messengers) {
  var dispatch = useAppDispatch();
  var submit = useInitialSubmit();
  var chatHandler = function chatHandler(event) {
    var _ref = event,
      _ref$detail = _ref.detail,
      flag = _ref$detail.flag,
      initialMessage = _ref$detail.initialMessage;
    dispatch(setChatOpen(flag));
    dispatch(setMenuOpen(false));
    submit(initialMessage);
  };
  var menuHandler = function menuHandler(event) {
    var _ref2 = event,
      flag = _ref2.detail.flag;

    // 2, так как может быть 1 параметр, где только наш чат
    var hasMessengersVariants = messengers.length > 1;
    dispatch(setChatOpen(!hasMessengersVariants && flag));
    dispatch(setMenuOpen(hasMessengersVariants && flag));
  };
  useEffect(function () {
    window.addEventListener(CHAT_WIDGET_EVENT_CHAT, chatHandler);
    window.addEventListener(CHAT_WIDGET_EVENT_MENU, menuHandler);
    return function () {
      window.removeEventListener(CHAT_WIDGET_EVENT_CHAT, chatHandler);
      window.removeEventListener(CHAT_WIDGET_EVENT_MENU, menuHandler);
    };
  }, []);
};